module.exports = __webpack_public_path__ + "img/salman1.481d9a6e.jpg";